export default __webpack_public_path__ + "static/media/green-dark.953e06a0.svg";